import Styled from 'styled-components';

import { media } from '../../lib/StyledComponents';

export const horizontalGutterSize: string = '1em';
export const verticalGutterSize: string = '3.5em';

export const RowSpan = Styled.div`
  margin-bottom: ${horizontalGutterSize};
`;

RowSpan.displayName = 'RowSpan';

export const columns: number = 12;
export const leftColspan: number = 8.5;
export const rightColspan: number = 3.5;
export const splitColspan: number = columns / 2;

export const LayoutContainer = Styled.div`
  display: flex;
  flex-wrap: wrap;
  flex-direction: column;

  ${media.medium`
    flex-direction: row;
  `}
`;

LayoutContainer.displayName = 'LayoutContainer';

export const FixedLayoutContainer = Styled(LayoutContainer)`
  ${media.mediumLarge`
    flex-direction: row;
  `}
`;

FixedLayoutContainer.displayName = 'FixedLayoutContainer';
